import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Avatar, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface CardsDashboardProps {
  title: string;
  value: number | string;
  color: string;
  icon: ReactNode;
}

export default function CardsDashboard({
  title,
  value,
  color,
  icon,
}: CardsDashboardProps) {
  return (
    <CardContent
      sx={{ padding: 0, marginBottom: { xs: -2, sm: -3, md: -2, lg: -5 } }}
    >
      <Stack p={1}>
        <Card elevation={4} sx={{ marginBottom: 2, borderRadius: 3 }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              height: { xs: 110, sm: 120, md: 90, lg: 110 },
              padding: 3,
              position: "relative",
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: 30,
                backgroundColor: color,
              },
            }}
          >
            <Stack
              direction="row"
              sx={{
                alignItems: "flex-start",
                justifyContent: "space-between",
                marginBottom: 2,
              }}
              spacing={3}
            >
              <Stack spacing={1}>
                <Typography variant="h4" fontWeight={600} color={color}>
                  {value}
                </Typography>
                <Typography variant="button" fontWeight={600}>
                  {title}
                </Typography>
              </Stack>
              <Avatar
                sx={{
                  backgroundColor: color,
                  height: "56px",
                  width: "56px",
                }}
              >
                {icon}
              </Avatar>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </CardContent>
  );
}
